import "./RegularIconText.scss";

const RegularIconText = ({
	icon,
	text,
	width = "350px",
	whiteText,
	boldText,
	adultosMayoresCase,
	inNavbar,
	inResponsiveNavbar,
}) => {
	return (
		<div
			className={`regularIconText-container ${
				adultosMayoresCase && "adultos-mayores-case"
			} ${inNavbar && "in-navbar"} ${
				inResponsiveNavbar && "in-responsive-navbar"
			}`}
			style={{ width: width }}
		>
			<img
				src={icon}
				alt="Content Icon"
				className={`regularIconText-icon ${
					inResponsiveNavbar && "in-responsive-navbar"
				}`}
			/>
			<div className="regularIconText-text-container">
				{boldText && (
					<h4
						className={
							`
								${
									!inResponsiveNavbar &&
									!inNavbar &&
									`t4 no-space ${whiteText ? "c-white" : "c-black"}`
								}
								${inNavbar && "body-16 bold no-space c-black"} 
								${inResponsiveNavbar && "body-14 no-space c-dark-blue"}
							`
						}
					>
						{boldText}
						{/* {inNavbar && ":"} */}
					</h4>
				)}

				{text && !inNavbar && (
					<p
						className={`
						regularIconText-text body-16 no-space  
						${boldText && "mt-20"}
						${whiteText ? "c-white" : "c-black"}`}
					>
						{text}
					</p>
				)}

				{text && inNavbar && <p className="body-16 no-space mt-5">{text}</p>}
			</div>
		</div>
	);
};

export default RegularIconText;
